import * as React from 'react';

export function useControlledState<T>(value?: T, setValue?: (value: T | undefined) => void) {
  const [_value, _setValue] = React.useState<T | undefined>();

  if (setValue !== undefined) {
    return [value, setValue] as const;
  }
  return [_value, _setValue] as const;
}
